import { Apartment } from '@/types';
import * as apartmentRepository from '@/repository/apartmentRepository';

export const apartmentService = {
  listenToApartments: (
    tripId: string, 
    callback: (apartments: Apartment[]) => void
  ): (() => void) => {
    return apartmentRepository.listenToApartments(tripId, callback);
  },

  addApartment: (
    tripId: string, 
    apartment: Omit<Apartment, 'id'>
  ): Promise<string> => {
    const newApartment = {
      ...apartment,
      currentOccupancy: 0,
      billStatus: 'not_sent' as const,
      isPaid: false,
    };
    return apartmentRepository.addApartment(tripId, newApartment);
  },

  updateApartment: (
    tripId: string, 
    apartmentId: string,
    data: Partial<Apartment>
  ): Promise<void> => {
    return apartmentRepository.updateApartment(tripId, apartmentId, data);
  },

  deleteApartment: (
    tripId: string, 
    apartmentId: string
  ): Promise<void> => {
    return apartmentRepository.deleteApartment(tripId, apartmentId);
  },
};
